import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CircularProgressWithLabel from './CircularProgressWithLabel';
import styles from './createVideo.module.scss';
import colors from '../../utils/colors';
import { UPLOAD_REMOVE } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import sanity from '../../sanity';
import { CONVERT_FINISHED_STATUS } from '../../constants';
import Event from '../../core/entitites/event.entity';
import fetch from '../../fetch';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from 'react-device-detect';
import { CARDS_KEYS_MAP } from './Home/constants';

const mapStateToProps = (state) => ({
    events: state.event.events,
    isAdmin: state.user.currentUser.groups && state.user.currentUser.groups.includes('Admin'),
    user: state.user.currentUser,
    company: state.common.company,
    upload: state.common.upload,
    event: state.event.events,
    connected_account: state.common.connected_account
});

const mapDispatchToProps = (dispatch) => ({
    onRemoveUpload: (payload) => dispatch({ type: UPLOAD_REMOVE, payload })
});

const Share = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [correlationId, setCorrelationId] = useState('');
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchId = async () => {
            const correlationId = await props.createEvent();
            setCorrelationId(correlationId);
        };
        if (props.selectedCard === CARDS_KEYS_MAP.CREATE_LINK) {
            if (props.fileUpload) {
                if (props.connected_account?.onboarded) {
                    fetchId();
                } else {
                    props.setShowOnboardingMessage(true);
                }
            }
        }
    }, [props.selectedCard]);

    useEffect(() => {
        if (correlationId) {
            if (correlationId === props.event[props.event.length - 1]?.correlation_id) {
                const lastEvent = props.event[props.event.length - 1];
                setEvent(lastEvent);

                const isUploadFinished =
                    correlationId === event?.correlation_id &&
                    event?.processingStatus === CONVERT_FINISHED_STATUS;

                props.setCardTitle(isUploadFinished ? t('ShareLink') : t('CreateLink'));
            }
        }
    }, [props.event, correlationId]);

    useEffect(() => {
        if (correlationId && event) {
            if (
                correlationId === event?.correlation_id &&
                event?.processingStatus === CONVERT_FINISHED_STATUS
            ) {
                props.setLinkCreated(true);
            }
        }
    }, [event, correlationId]);

    const sendMail = async () => {
        try {
            setLoading(true);
            await fetch.Event.EventShareMail(event.id);
        } catch (error) {
            console.log('ERROR: ', error);
        } finally {
            setLoading(false);
            props.setFinishedFlag((prev) => !prev);
            props.setJobId(uuidv4());
            props.setSelectedCard(CARDS_KEYS_MAP.UPLOAD);
        }
    };

    return (
        <>
            {correlationId === event?.correlation_id &&
            event?.processingStatus === CONVERT_FINISHED_STATUS ? (
                <>
                    <Typography
                        fontSize={'28px'}
                        sx={{ lineHeight: '100%', letterSpacing: '-0.56px', color: 'white' }}>
                        {t('AllSet')}
                    </Typography>
                </>
            ) : (
                <>
                    <Typography
                        fontSize={'28px'}
                        sx={{ lineHeight: '100%', letterSpacing: '-0.56px', color: 'white' }}>
                        {t('EarnMoney')}
                    </Typography>
                </>
            )}
            {props.showOnboardingMessage ? (
                <Box className={styles.shareContent}>
                    {props?.videoProgress?.upload_show && <Box className={styles.flexCenter}></Box>}
                    <Box sx={{ marginTop: '1rem' }}>
                        <Typography
                            fontSize={'24px'}
                            sx={{ lineHeight: '100%', letterSpacing: '-0.48px' }}
                            textAlign={'center'}
                            color={colors.primary}>
                            {t('RegisterBankAccountHeader')}
                        </Typography>
                        <Typography
                            fontSize={'18px'}
                            sx={{ lineHeight: '100%', marginTop: '1rem' }}
                            textAlign={'center'}>
                            {t('RegisterBankAccountText')}
                        </Typography>

                        <Button
                            onClick={() => history.push('/onboard')}
                            sx={{
                                '&:active, &:focus, &:hover': {
                                    background: 'white',
                                    color: 'black'
                                }
                            }}
                            fullWidth>
                            <Typography
                                sx={{
                                    fontFamily: 'InstrumentSans-semibold',
                                    fontSize: '18px',
                                    lineHeight: '100%',
                                    letterSpacing: '-0.36px'
                                }}>
                                {t('RegisterBankAccount')}
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            ) : (
                <>
                    {props?.videoProgress?.upload_show ? (
                        <Box className={styles.shareContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItem: 'center'
                                }}>
                                <CircularProgressWithLabel
                                    color={colors.primary}
                                    showValue
                                    textColor={'white'}
                                    size={70}
                                    value={props?.videoProgress?.upload_progress}
                                />
                            </Box>
                            <Typography
                                fontSize={'24px'}
                                textAlign={'center'}
                                sx={{
                                    lineHeight: '100%',
                                    letterSpacing: '-0.48px',
                                    marginY: '1rem'
                                }}>
                                {t('UploadWait')}
                            </Typography>
                            <Typography
                                fontSize={'18px'}
                                textAlign={'center'}
                                sx={{ lineHeight: '100%' }}>
                                {t('InHurry')}
                            </Typography>
                        </Box>
                    ) : !correlationId || !event ? (
                        <Box className={styles.shareContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItem: 'center'
                                }}>
                                <CircularProgressWithLabel
                                    color={colors.primary}
                                    showValue
                                    textColor={'white'}
                                    size={70}
                                    value={99}
                                />
                            </Box>
                            <Typography
                                fontSize={'24px'}
                                textAlign={'center'}
                                sx={{
                                    lineHeight: '100%',
                                    letterSpacing: '-0.48px',
                                    marginY: '1rem'
                                }}>
                                {t('UploadWait')}
                            </Typography>
                            <Typography
                                fontSize={'18px'}
                                textAlign={'center'}
                                sx={{ lineHeight: '100%' }}>
                                {t('InHurry')}
                            </Typography>
                        </Box>
                    ) : correlationId &&
                      event &&
                      event?.processingStatus !== CONVERT_FINISHED_STATUS ? (
                        <Box className={styles.shareContent}>
                            {props?.videoProgress?.upload_show && (
                                <Box className={styles.flexCenter}></Box>
                            )}
                            <Box sx={{ marginTop: '1rem' }}>
                                <Typography
                                    fontSize={'14px'}
                                    textAlign={'center'}
                                    sx={{ marginTop: '1rem', opacity: '0.5' }}>
                                    {/* {t('Notify')} */}
                                    Your upload has finished, we are publishing the video. This may
                                    take a while but you can click the button in order to be
                                    notified when the publishing is done
                                </Typography>
                                {loading ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItem: 'center',
                                            marginTop: '2rem'
                                        }}>
                                        <CircularProgress
                                            sx={{ color: colors.primary }}
                                            size={60}
                                        />
                                    </Box>
                                ) : (
                                    <Button
                                        onClick={() => sendMail()}
                                        sx={{
                                            '&:active, &:focus, &:hover': {
                                                background: 'white',
                                                color: 'black'
                                            }
                                        }}
                                        fullWidth>
                                        <Typography
                                            sx={{
                                                fontFamily: 'InstrumentSans-semibold',
                                                fontSize: '18px',
                                                lineHeight: '100%',
                                                letterSpacing: '-0.36px'
                                            }}>
                                            {t('MailMe')}
                                        </Typography>
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    ) : correlationId === event?.correlation_id &&
                      event?.processingStatus === CONVERT_FINISHED_STATUS ? (
                        <Box className={styles.readyLink}>
                            <Typography sx={{ lineHeight: 'normal', letterSpacing: '-0.32px' }}>
                                {t('YourWork')}
                            </Typography>
                            <Box position="relative">
                                <TextField
                                    sx={{
                                        borderRadius: '16px',
                                        height: 'auto',
                                        backgroundColor: colors.primaryLightGray,
                                        '& .MuiInputBase-input::placeholder': {
                                            color: 'black',
                                            opacity: 1
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                border: 'none'
                                            }
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            // <Box
                                            //     position="absolute"
                                            //     right="8px"
                                            //     top="50%"
                                            //     transform="translateY(-50%)">
                                            <Button
                                                onClick={() =>
                                                    navigator.clipboard.writeText(
                                                        `${window.location.origin}/watch/${event.id}`
                                                    )
                                                }
                                                sx={{
                                                    '&:hover': {
                                                        backgroundColor: colors.primary
                                                    }
                                                }}>
                                                {t('CopyLink')}
                                            </Button>
                                            // </Box>
                                        )
                                    }}
                                    value={
                                        `${window.location.origin}/events/${event.slug}`.length > 16
                                            ? `${`${window.location.origin}/events/${event.slug}`.substring(
                                                  0,
                                                  19
                                              )}...`
                                            : `${window.location.origin}/events/${event.slug}`
                                    }
                                    fullWidth
                                />
                            </Box>

                            <Typography
                                sx={{ marginTop: '1rem' }}
                                color={'#6C6C6C'}
                                fontSize={'12px'}
                                textAlign={'center'}>
                                {t('FindLinks')}
                                <span style={{ color: 'black' }}> {t('Library')}</span>{' '}
                            </Typography>
                        </Box>
                    ) : null}
                </>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Share);
